/**
 * Artist Creation & Edit Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Artist Form guide.
 */
export const artistFormTourConfig = {
  id: 'artist-form-onboarding',
  storageKey: 'triad_tour_artist_form_completed',
  steps: [
    {
      id: 'artist-name',
      target: '[data-tour="artist-name"]',
      titleKey: 'tour.artistForm.nameTitle',
      descriptionKey: 'tour.artistForm.nameDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'artist-bio',
      target: '[data-tour="artist-bio"]',
      titleKey: 'tour.artistForm.bioTitle',
      descriptionKey: 'tour.artistForm.bioDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'artist-tags',
      target: '[data-tour="artist-tags"]',
      titleKey: 'tour.artistForm.tagsTitle',
      descriptionKey: 'tour.artistForm.tagsDesc',
      position: 'top',
      align: 'start'
    },
    {
      id: 'artist-save-btn',
      target: '[data-tour="artist-save-btn"]',
      titleKey: 'tour.artistForm.saveTitle',
      descriptionKey: 'tour.artistForm.saveDesc',
      position: 'bottom',
      align: 'end'
    }
  ]
};

export default artistFormTourConfig;
